import React from 'react';
export function SocialProofBar() {
  return <section className="w-full bg-steel px-5 py-6 sm:py-8" data-id="element-163" data-mp="3fyhnbo0xqj8f">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-164" data-mp="2eta8kamjoejg">
        <p className="text-sm font-semibold text-white sm:text-base" data-id="element-165" data-mp="29u5zdjzmegt4">
          <span className="tracking-tight text-gold" data-id="element-166" data-mp="29scpzwxmhihf">⭐⭐⭐⭐⭐</span> 4.9/5 · Trusted by 500+ Visual
          Arts teachers across 7 countries
        </p>
      </div>
    </section>;
}